import React from 'react'
import Type from 'Components/Type'
import L from 'Components/L'
import { RadioCardImg, Fade } from './Configurator-styles'

export const RadioCard = ({ isDisabled, image, checked, label, onSelect }) => {
  const Icon = image
  return (
    <L display="grid" gap={1} pY={1} pX={1} selectable={isDisabled} onMouseUp={onSelect}>
      <L display="grid" jc="center" ji="center" ai="center" ac="center" color={checked ? 'primaryHue' : 'inherit'}>
        <RadioCardImg>
          <Fade as={Icon} />
        </RadioCardImg>
        <Type as={Fade} variant="labelLargeBoldResponsive">
          {label}
        </Type>
      </L>
    </L>
  )
}

export default RadioCard
